import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { Picker } from '@react-native-picker/picker';
import FormInput from '../common/FormInput';
import { SCHOOL_TYPES, STUDY_YEARS } from '../../utils/profileConstants';

const StudentForm = ({
  schoolDetails = {},
  onSchoolDetailsChange,
  errors = {}
}) => {
  const handleChange = (field, value) => {
    onSchoolDetailsChange({
      ...schoolDetails,
      [field]: value
    });
  };

  return (
    <View style={styles.container}>
      <FormInput
        label="School Name"
        value={schoolDetails.schoolName || ''}
        onChangeText={(value) => handleChange('schoolName', value)}
        error={errors.schoolName}
        placeholder="Enter your school name"
      />

      <FormInput
        label="Course/Program"
        value={schoolDetails.course || ''}
        onChangeText={(value) => handleChange('course', value)}
        error={errors.course}
        placeholder="Enter your course or program"
      />

      <View style={styles.pickerField}>
        <Text style={styles.label}>School Type</Text>
        <View style={styles.pickerWrapper}>
          <Picker
            selectedValue={schoolDetails.schoolType || ''}
            onValueChange={(value) => handleChange('schoolType', value)}
            style={styles.picker}
            mode="dropdown"
          >
            <Picker.Item label="Select School Type" value="" />
            {SCHOOL_TYPES.map((type) => (
              <Picker.Item key={type} label={type} value={type} />
            ))}
          </Picker>
        </View>
      </View>

      <View style={styles.pickerField}>
        <Text style={styles.label}>Year of Study</Text>
        <View style={styles.pickerWrapper}>
          <Picker
            selectedValue={schoolDetails.yearOfStudy || ''}
            onValueChange={(value) => handleChange('yearOfStudy', value)}
            style={styles.picker}
            mode="dropdown"
          >
            <Picker.Item label="Select Year of Study" value="" />
            {STUDY_YEARS.map((year) => (
              <Picker.Item key={year} label={year} value={year} />
            ))}
          </Picker>
        </View>
      </View>

      <FormInput
        label="Expected Completion Year"
        value={schoolDetails.expectedCompletion || ''}
        onChangeText={(value) => handleChange('expectedCompletion', value)}
        error={errors.expectedCompletion}
        placeholder="YYYY"
        keyboardType="numeric"
        maxLength={4}
      />

      <FormInput
        label="Additional Information"
        value={schoolDetails.additionalInfo || ''}
        onChangeText={(value) => handleChange('additionalInfo', value)}
        error={errors.additionalInfo}
        placeholder="Any additional information about your studies"
        multiline
        numberOfLines={3}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingVertical: 4,
    width: '100%',
  },
  pickerField: {
    marginBottom: 12,
  },
  label: {
    fontSize: 12,
    marginBottom: 6,
    color: '#64748B',
    fontWeight: '600',
    marginLeft: 2,
  },
  pickerWrapper: {
    backgroundColor: '#F8FAFC',
    borderWidth: 1.2,
    borderColor: '#EDF2F7',
    borderRadius: 10,
    overflow: 'hidden',
  },
  picker: {
    height: 44,
    width: '100%',
    color: '#1E293B',
  }
});

export default StudentForm;
